import styled from "styled-components";

import BIButton from "../../components/common/Button";

import { colors } from "../../theme/colors";

export const StartTestButton = styled(BIButton)`
  background-color: ${colors.secondary} !important;
  color: ${colors.primary} !important;
  border: 1px solid ${colors.secondary} !important;
  border-radius: 25px !important;
  padding: 8px 24px !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  min-width: 180px !important;
  box-shadow: none !important;
  text-transform: none !important;

  &:hover {
    background-color: white !important;
    border: 1px solid ${colors.primary} !important;
  }
`;
